module.exports = __webpack_public_path__ + "static/media/momrah.gov.4e0038d1.webp";